import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';
import helpers from '../../helpers/index';
import DatePicker from "react-datepicker";

import {
    MemberLoanDetails, LoanInfo, LoanInfoError, TypeOfLoanList,
    TypeOfLoanListResponse, ResponseNumberDataResponse, ResponseMemberLoanDetails,
    CreateLoanInput, InterestRate
} from '../../interface/ILoanManagement'

import { Response, ApiResponse } from '../../interface/IResponse';

import loanManagementService from './loanManagementService';

import SuccessModal from '../../components/Modal/SuccessModal';

import SignatureCanvas from '../../components/Signature/SignatureCanvas';

import SignatureModal from '../../components/Signature/SignatureModal';


function CreateLoan() {


    var dispatch = useDispatch();
    const navigate = useNavigate();
    const [isReadOnly, setIsReadOnly] = useState(false);

    const [searchMember, setSearchMember] = useState<string>('');
    const [loanInfo, setLoanInfo] = useState<LoanInfo>({ startDate: new Date() });
    const [loanInfoError, setLoanInfoError] = useState<LoanInfoError>({});
    const [typeOfLoanList, setTypeOfLoanList] = useState<TypeOfLoanList[]>([]);
    const [interestRateValue, setInterestRateValue] = useState<number[] | null>(null);
    const [loanTerms, setLoanTerms] = useState<number[] | null>(null);
    const [memberLoanDetails, setMemberLoanDetails] = useState<MemberLoanDetails | null>(null);
    const [createLoanInput, setCreateLoanInput] = useState<CreateLoanInput>({});
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [loanId, setLoanId] = useState<number>(0);
    const { memberId } = useParams<{ memberId: string; }>();
    const [signatureModalOpen, setSignatureModalOpen] = useState(false);

    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }


    async function typeOfLoanChange(event: ChangeEvent<HTMLSelectElement>) {

        var value: number = parseInt(event.target.value);

        setLoanInfo((prevState) => ({
            ...prevState,
            typeOfLoanId: value
        }));

        await getInterestRateTermsByTypeOfLoan(value);
    }

    function amountLoanChange(event: ChangeEvent<HTMLInputElement>) {
        let value = event.target.value;

        // Ensure the value is between the min and max range
        // if (value !== '') {
        //     const numValue = parseInt(value);

        //     // Set to min or max if outside the range
        //     if (numValue < 1) {
        //         value = ""; // Allow empty input to remove 0
        //     } else if (numValue > Number(memberLoanDetails?.maximumLoan)) {
        //         value = String(memberLoanDetails?.maximumLoan);
        //     }
        // }

        // Update the state with the corrected value
        setLoanInfo({
            ...loanInfo,
            amountLoan: value === '' ? undefined : Number(value), // Handle empty input gracefully
        });
    }


    function loanTermChange(event: ChangeEvent<HTMLSelectElement>) {

        setLoanInfo((prevState) => ({
            ...prevState,
            loanTerm: Number(event.target.value)
        }));


    }

    function modeOfPaymentChange(event: ChangeEvent<HTMLSelectElement>) {
        setLoanInfo((prevState) => ({
            ...prevState,
            isMonthly: Boolean(event.target.value)
        }));
    }

    function interestRateChange(event: ChangeEvent<HTMLSelectElement>) {
        setLoanInfo((prevState) => ({
            ...prevState,
            interestRate: Number(event.target.value)
        }));
    }

    function CancelApplyLoanButtonClick() {
        navigate('/Admin/LoanManagement');

    }

    async function loadTypeOfLoansList() {

        try {

            var response: AxiosResponse<TypeOfLoanListResponse> = await loanManagementService.listTypeOfLoan();

            setTypeOfLoanList(response.data.result);

        }
        catch (err) {
            throw err;
        }


    }

    async function loadInterestRatesValue(typeOfLoanId: number) {

        try {

            var result = null;

            if (typeOfLoanId) {


                var response: AxiosResponse<ResponseNumberDataResponse> = await loanManagementService.getInterestRatesValue(typeOfLoanId);

                result = response.data.result;
            }

            setInterestRateValue(result ?? null);

        }
        catch (err) {
            throw err;
        }


    }

    async function getInterestRateTermsByTypeOfLoan(typeofLoanId: number) {
        try {

            var interestRate: number[] = [];
            var loanTerm: number[] = [];

            if (typeofLoanId) {

                var response: AxiosResponse<ApiResponse<InterestRate[]>> = await loanManagementService.getInterestRateTermsByTypeOfLoan(typeofLoanId);

                response.data.result.forEach(function (item) {

                    if (item.interestRate != null) {
                        interestRate.push(item.interestRate);
                    }

                    if (item.months != null) {
                        loanTerm.push(item.months);
                    }
                });

            }

            if (interestRate.length > 0) {

                let distinctInterestRate = Array.from(new Set(interestRate));

                setInterestRateValue(distinctInterestRate);
            }
            else {
                setInterestRateValue(null);
            }

            if (loanTerm.length > 0) {
                let distinctLoanTerm = Array.from(new Set(loanTerm));

                setLoanTerms(distinctLoanTerm);
            }
            else {
                setLoanTerms(null);
            }


        }
        catch (err) {
            console.log('getInterestRateTermsByTypeOfLoan err:: ', err);
        }
    }

    async function loadLoanTerms() {

        try {

            var response: AxiosResponse<ResponseNumberDataResponse> = await loanManagementService.getLoanTerms();

            setLoanTerms(response.data.result ?? null);

        }
        catch (err) {
            throw err;
        }


    }


    async function getMemberDetails() {
        try {

            if (memberId) {
                var response: AxiosResponse<ResponseMemberLoanDetails> = await loanManagementService.getMemberLoanDetailsByMemberId(memberId);

                setMemberLoanDetails(response.data.result || null);
            } else {
                navigate("/Admin/LoanManagement");
            }


        }
        catch (err) {
            throw err;
        }

    }


    const onClose = () => {
        setIsSuccessModalOpen(false);
        navigate('/Admin/LoanStatusDetails/' + loanId);
    };

    function isAllowedSave() {

        var hasNoError: boolean = true;
        setLoanInfoError({});
        if (!memberLoanDetails?.firstname || !memberLoanDetails.lastname || !memberLoanDetails.membershipId
            || !memberLoanDetails.email || !memberLoanDetails.amountSubscribe || !memberLoanDetails.memberId) {
            setLoanInfoError((prevState) => ({
                ...prevState,
                memberInfo: "Member is required"
            }));
        }

        if (!loanInfo?.typeOfLoanId) {
            hasNoError = false;
            setLoanInfoError((prevState) => ({
                ...prevState,
                typeOfLoan: "Type of loan is required"
            }));
        }

        if (!loanInfo?.amountLoan) {
            hasNoError = false;
            setLoanInfoError((prevState) => ({
                ...prevState,
                amountLoan: "Loan amount is required"
            }));
        }

        if (!loanInfo?.loanTerm) {
            hasNoError = false;
            setLoanInfoError((prevState) => ({
                ...prevState,
                loanTerm: "Loan term is required"
            }));
        }

        if (!loanInfo?.interestRate) {
            hasNoError = false;
            setLoanInfoError((prevState) => ({
                ...prevState,
                interestRateError: "Interest rate is required"
            }));
        }

        return hasNoError;

    }


    async function handleSubmitClick() {

        try {
            document.querySelector('.loader-container')?.classList.add('loader');
            var isAllowed = isAllowedSave();

            if (isAllowed) {


                const newLoanInput = {
                    memberId: memberLoanDetails?.memberId,
                    typeOfLoanId: loanInfo?.typeOfLoanId,
                    amountLoan: loanInfo?.amountLoan,
                    loanTerm: loanInfo?.loanTerm,
                    interestRate: loanInfo?.interestRate,
                    isMainLoan: true,
                    serviceFee: 1000,
                    startDate: loanInfo?.startDate || new Date()    
                };


                var response: AxiosResponse<ResponseMemberLoanDetails> = await loanManagementService.createLoan(newLoanInput);

                setLoanId(Number(response.data.result));

                setIsSuccessModalOpen(true);

            }
        }
        catch (err) {
            throw err;
        }
        finally {
            document.querySelector('.loader-container')?.classList.remove('loader');
        }
    }

    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');


            await getMemberDetails();
            await loadTypeOfLoansList();
            getPermission();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (<Layout>

        <SuccessModal message='Loan created successfully' isOpen={isSuccessModalOpen} onClose={onClose} ></SuccessModal>
        <div className="title-container">
            <div className="dv-title">
                <h1>Apply for a Loan</h1>
            </div>
            <div className="title-btn-container vertical-flex-bottom">
                <button
                    type="button"
                    id="btnCancel"
                    onClick={CancelApplyLoanButtonClick}
                    className="btn-white-green-2 center-middle"
                >
                    Cancel
                </button>
                &nbsp;
                <button
                    disabled={isReadOnly}
                    type="button"
                    id="btnSubmit"
                    onClick={handleSubmitClick}
                    className="btn-green-2 center-middle"
                >
                    Submit
                </button>
            </div>
        </div>
        <br />
        <div className='content-container'>
            <div className='padding-container'>
                <div className='title'>Member Info</div>
                <br />
                <div>


                    <div className='content-container-5'>
                        <input type="hidden" name="hdnMemberId" id="hdnMemberId" value={memberLoanDetails?.memberId} />
                        <div>
                            <div className='label-2'>Member Name:</div>
                            <div className='label-2 font-bold' id='lblMemberName'>
                                {memberLoanDetails?.firstname} {memberLoanDetails?.lastname}
                            </div>
                        </div>
                        <div>
                            <div className='label-2'>ID:</div>
                            <div className='label-2 font-bold' id='lblId'>
                                {memberLoanDetails?.membershipId}
                            </div>
                        </div>
                        <div>
                            <div className='label-2'>Email:</div>
                            <div className='label-2 font-bold' id='lblEmail'>
                                {memberLoanDetails?.email}
                            </div>
                        </div>
                        <div>
                            <div className='label-2'>Capital Shares:</div>
                            <div className='label-2 font-bold' id='lblInitialPaidAmount'>
                                {helpers.formatNumber(memberLoanDetails?.initialPaidAmount ?? 0)}
                            </div>
                        </div>
                        <div>
                            <div className='label-2'>Loanable Amount:</div>
                            <div className='label-2 font-bold' >
                                {helpers.formatNumber(memberLoanDetails?.maximumLoan ?? 0)}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label className='label-error-1'>{loanInfoError.memberInfo}</label>
                    </div>

                    <div className='label-1'>Type of Loan:</div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <select
                            disabled={isReadOnly}
                            className={loanInfoError?.typeOfLoan ? "textbox-red-2" : "textbox-green-2"}
                            value={loanInfo?.typeOfLoanId}
                            onChange={typeOfLoanChange}
                        >
                            <option value=""></option>
                            {typeOfLoanList.map(({ typeOfLoanId, name }) => (
                                <option key={typeOfLoanId} value={typeOfLoanId?.toString()}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className='label-error-1'>{loanInfoError.typeOfLoan}</label>
                    </div>

                    <div>
                        <div className='label-1'>
                            Start Date:
                        </div>
                    </div>
                    <div>
                        <DatePicker className={"textbox-green-2"} name="startDate" id="txtStartDate"
                            selected={loanInfo.startDate || null}
                            disabled={isReadOnly}
                            onChange={(date: Date | null) => {
                                setLoanInfo((prevState) => ({
                                    ...prevState,
                                    startDate: date || new Date(),
                                }));
                            }} />

                    </div>
                    <div>
                        <label className='label-error-1'></label>
                    </div>
                    <div className="label-1">Loan Amount:</div>
                    <div>
                        <input
                            min="1"
                            max="250"
                            type="number"
                            disabled={isReadOnly}
                            className={loanInfoError?.amountLoan ? "textbox-red-2" : "textbox-green-2"}
                            name="loanAmount"
                            id="txtLoanAmount"
                            placeholder="Loan Amount"
                            value={loanInfo?.amountLoan}
                            onChange={amountLoanChange}
                        />
                    </div>
                    <div>
                        <label className='label-error-1'>{loanInfoError.amountLoan}</label>
                    </div>

                    <div className='label-1'>Loan Term:</div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <select
                            disabled={isReadOnly}
                            className={loanInfoError?.loanTerm ? "textbox-red-2" : "textbox-green-2"}
                            value={loanInfo?.loanTerm}
                            onChange={loanTermChange}
                        >
                            <option value=""></option>
                            {loanTerms?.map((term, index) => (
                                <option key={index} value={term}>
                                    {term}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className='label-error-1'>{loanInfoError.loanTerm}</label>
                    </div>

                    <div className='label-1'>Interest Rate:</div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <select
                            disabled={isReadOnly}
                            className={loanInfoError?.interestRateError ? "textbox-red-2" : "textbox-green-2"}
                            value={loanInfo?.interestRate}
                            onChange={interestRateChange}
                        >
                            <option value=""></option>
                            {interestRateValue?.map((rate, index) => (
                                <option key={index} value={rate}>
                                    {rate}%
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className='label-error-1'>{loanInfoError.interestRateError}</label>
                    </div>
                </div>

            </div>
        </div>
    </Layout>);


}

export default CreateLoan;